// Renewal (rebaseline) helpers for PermissionRequest.jsx. Pure functions, no React.
// The server (validator storeResults) re-checks everything here at submit.

const byExpiryThenNewest = (a, b) => {
    // Has accessEndDate first, then accessEndDate ascending (soonest expiry first)
    const aExpiry = a.accessEndDate || '';
    const bExpiry = b.accessEndDate || '';
    if (aExpiry && !bExpiry) return -1;
    if (!aExpiry && bExpiry) return 1;
    if (aExpiry && bExpiry) return aExpiry.localeCompare(bExpiry);
    // Then by createdAt descending (most recent first)
    return (b.createdAt || '').localeCompare(a.createdAt || '');
};

// #9: the picker lists only APPROVED requests that have not been renewed yet.
export const renewalPickerFilter = (requests) => (requests || [])
    .filter(r => r.requestId && !r.requestId.startsWith('JOB-')
        && r.status === 'APPROVED'
        && !r.renewalRequestId
        && !r.supersededBy
        && r.expiryState !== 'SUPERSEDED_AT_BACKFILL')
    .sort(byExpiryThenNewest);

// Same refusals (and texts) as the server. null = renewable.
export const renewalRefusal = (data) => {
    const d = data || {};
    if (d.expiryState === 'SUPERSEDED_AT_BACKFILL') {
        const cand = d.supersededByCandidate || '';
        return `${d.requestId} looks renewed by ${cand}; renew ${cand} instead.`;
    }
    if (d.status === 'REBASELINED' || d.renewalRequestId || d.supersededBy) return 'This request was already renewed.';
    if (d.status !== 'APPROVED') return 'Only an approved request can be renewed.';
    return null;
};

// One id per submit click, shared by every risk-type group of that submit.
export const newSubmissionId = () => {
    const c = typeof crypto !== 'undefined' ? crypto : null;
    if (c && typeof c.randomUUID === 'function') return c.randomUUID();
    const bytes = new Uint8Array(16);
    c.getRandomValues(bytes);
    return Array.from(bytes, b => b.toString(16).padStart(2, '0')).join('');
};

// #1: renewal fields of the storeResults payload. previous* are kept unchanged.
export const renewalSubmitFields = ({ originalRequestId, previousApprovalId, renewalSubmissionId }) => ({
    previousRequestId: originalRequestId,
    previousApprovalId: previousApprovalId,
    previousViewerUrl: `https://permissions-access-management.tse.amazon.dev/viewer?id=${originalRequestId}`,
    originalRequestId,
    renewalSubmissionId,
});

// #5: what step 1 shows. A legacy 'skip' value behaves like "no original yet".
export const renewalStep1View = (requestType, originalRequestId) => {
    const id = originalRequestId || '';
    const loaded = requestType === 'renewal' && !!id && id !== 'skip';
    const showPicker = requestType === 'renewal' && (!id || id === 'skip');
    return { loaded, showTypeCards: !loaded, showPicker, showSkip: false, showChip: loaded };
};
